import hands from "../../assets/img/info/hands.png";
import light from "../../assets/img/info/light.png";
import rocket from "../../assets/img/info/rocket.png";
import chart from "../../assets/img/info/chart.png";
import styles from "./MainScreenInfo.module.css";
import { useRef } from "react";
import { useIsVisible } from "react-is-visible";

export const MainScreenInfoImg = () => {
  const isVisibleRef = useRef();
  const isVisible = useIsVisible(isVisibleRef);
  return (
    <svg
      width='1048'
      height='1111'
      viewBox='0 0 1048 1111'
      fill='none'
      ref={isVisibleRef}>
      <g filter='url(#filter0_f_517_1164)'>
        <ellipse
          cx='541.756'
          cy='556.565'
          rx='344.835'
          ry='344.569'
          transform='rotate(-45 541.756 556.565)'
          fill='#010682'
          fill-opacity='0.1'
        />
      </g>
      <path
        d='M439.97 524.821L439.442 580.233L528.628 668.364L583.512 668.364L671.643 580.233V525.349L582.985 436.69H528.101L439.97 524.821Z'
        fill='#22DAF9'
      />
      <path
        d='M448.041 526.75L447.549 578.34L530.585 660.393L581.684 660.393L663.737 578.34V527.242L581.193 444.697H530.094L448.041 526.75Z'
        fill='#001566'
      />
      <path
        d='M323.825 484.966L282.684 526.107V575.475L323.825 616.616L373.194 616.616L414.335 575.475V526.107L373.194 484.966L323.825 484.966Z'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M530.825 277.966L489.684 319.107V368.475L530.825 409.616L580.194 409.616L621.335 368.475V319.107L580.194 277.966L530.825 277.966Z'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M740.286 487.732L699.161 528.857L699.142 578.188L740.235 619.282L789.567 619.263L830.692 578.138L830.711 528.806L789.617 487.713L740.286 487.732Z'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M532.825 694.966L491.684 736.107V785.475L532.825 826.616L582.194 826.616L623.335 785.475V736.107L582.194 694.966L532.825 694.966Z'
        stroke='#0075FF'
        stroke-width='3'
      />
      <g filter='url(#filter1_d_517_1164)'>
        <path
          d='M327.026 496.709L292.635 531.1V572.369L327.026 606.76L368.295 606.76L402.686 572.369V531.1L368.295 496.709L327.026 496.709Z'
          fill='#F2F3F3'
        />
      </g>
      <g filter='url(#filter2_d_517_1164)'>
        <path
          d='M535.026 289.765L500.635 324.156V365.426L535.026 399.817L576.295 399.817L610.686 365.426V324.156L576.295 289.765L535.026 289.765Z'
          fill='#F2F3F3'
        />
      </g>
      <g filter='url(#filter3_d_517_1164)'>
        <path
          d='M743.48 498.522L709.102 532.9L709.086 574.138L743.437 608.49L784.675 608.474L819.053 574.096L819.069 532.858L784.718 498.506L743.48 498.522Z'
          fill='#F2F3F3'
        />
      </g>
      <g filter='url(#filter4_d_517_1164)'>
        <path
          d='M536.026 705.765L501.635 740.156V781.426L536.026 815.817L577.295 815.817L611.686 781.426V740.156L577.295 705.765L536.026 705.765Z'
          fill='#F2F3F3'
        />
      </g>
      <g filter='url(#filter5_d_517_1164)'>
        <rect
          x='395.738'
          y='481.623'
          width='12.5648'
          height='50.2206'
          transform='rotate(-45 395.738 481.623)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter6_d_517_1164)'>
        <rect
          x='415.481'
          y='461.881'
          width='12.5648'
          height='50.2206'
          transform='rotate(-45 415.481 461.881)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter7_d_517_1164)'>
        <rect
          x='453.982'
          y='423.38'
          width='12.5648'
          height='50.2206'
          transform='rotate(-45 453.982 423.38)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M440.16 438.187L293.676 291.703'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M479.154 399.193L451.041 371.08L451.557 310.392'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M400.673 476.687L372.56 448.574L312.859 448.104'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M458.917 418.445L396.773 356.3L399.261 301.531L369.175 271.445'
        stroke='#0075FF'
        stroke-width='3'
      />
      <g filter='url(#filter8_d_517_1164)'>
        <rect
          x='435.225'
          y='442.136'
          width='12.5648'
          height='50.2206'
          transform='rotate(-45 435.225 442.136)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter9_d_517_1164)'>
        <rect
          x='473.725'
          y='403.635'
          width='12.5648'
          height='50.2206'
          transform='rotate(-45 473.725 403.635)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M420.417 456.944L358.273 394.799L303.504 397.287L273.418 367.201'
        stroke='#0075FF'
        stroke-width='3'
      />
      <circle
        cx='450.836'
        cy='300.037'
        r='9'
        transform='rotate(-45 450.836 300.037)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='363.037'
        cy='264.545'
        r='9'
        transform='rotate(-45 363.037 264.545)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='266.28'
        cy='360.303'
        r='9'
        transform='rotate(-45 266.28 360.303)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='302.771'
        cy='449.101'
        r='9'
        transform='rotate(-45 302.771 449.101)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='287.032'
        cy='284.31'
        r='9'
        transform='rotate(-45 287.032 284.31)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <g filter='url(#filter10_d_517_1164)'>
        <rect
          x='716.394'
          y='626.56'
          width='12.5648'
          height='50.2206'
          transform='rotate(135 716.394 626.56)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter11_d_517_1164)'>
        <rect
          x='696.65'
          y='646.303'
          width='12.5648'
          height='50.2206'
          transform='rotate(135 696.65 646.303)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter12_d_517_1164)'>
        <rect
          x='658.15'
          y='684.804'
          width='12.5648'
          height='50.2206'
          transform='rotate(135 658.15 684.804)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M671.971 669.996L818.455 816.481'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M632.977 708.99L661.09 737.103L660.574 797.792'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M711.458 631.497L739.571 659.61L799.272 660.08'
        stroke='#0075FF'
        stroke-width='3'
      />
      <g filter='url(#filter13_d_517_1164)'>
        <rect
          x='676.906'
          y='666.047'
          width='12.5648'
          height='50.2206'
          transform='rotate(135 676.906 666.047)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M653.214 689.739L715.359 751.884L712.871 806.652L742.957 836.738'
        stroke='#0075FF'
        stroke-width='3'
      />
      <g filter='url(#filter14_d_517_1164)'>
        <rect
          x='638.406'
          y='704.549'
          width='12.5648'
          height='50.2206'
          transform='rotate(135 638.406 704.549)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M691.714 651.24L753.859 713.385L808.627 710.897L838.713 740.983'
        stroke='#0075FF'
        stroke-width='3'
      />
      <circle
        cx='660.542'
        cy='808.153'
        r='9'
        transform='rotate(90 660.542 808.153)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='750.094'
        cy='843.638'
        r='9'
        transform='rotate(135 750.094 843.638)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='845.851'
        cy='747.881'
        r='9'
        transform='rotate(135 845.851 747.881)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='809.542'
        cy='660.341'
        r='9'
        transform='rotate(90 809.542 660.341)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='825.099'
        cy='823.874'
        r='9'
        transform='rotate(135 825.099 823.874)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <g filter='url(#filter15_d_517_1164)'>
        <rect
          x='628.658'
          y='394.697'
          width='12.5551'
          height='50.2593'
          transform='rotate(45 628.658 394.697)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter16_d_517_1164)'>
        <rect
          x='647.4'
          y='413.439'
          width='12.5551'
          height='50.2593'
          transform='rotate(45 647.4 413.439)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter17_d_517_1164)'>
        <rect
          x='686.856'
          y='452.897'
          width='12.5551'
          height='50.2593'
          transform='rotate(45 686.856 452.897)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M671.074 438.099L817.671 291.502'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M710.037 477.064L738.172 448.929L798.86 449.399'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M632.603 398.643L660.738 370.508L661.254 310.806'
        stroke='#0075FF'
        stroke-width='3'
      />
      <g filter='url(#filter18_d_517_1164)'>
        <rect
          x='667.129'
          y='433.168'
          width='12.5551'
          height='50.2593'
          transform='rotate(45 667.129 433.168)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M690.802 456.841L752.995 394.648L807.762 397.094L837.871 366.985'
        stroke='#0075FF'
        stroke-width='3'
      />
      <g filter='url(#filter19_d_517_1164)'>
        <rect
          x='705.598'
          y='471.638'
          width='12.5551'
          height='50.2593'
          transform='rotate(45 705.598 471.638)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M652.332 418.371L714.524 356.178L712.078 301.411L742.188 271.302'
        stroke='#0075FF'
        stroke-width='3'
      />
      <circle
        cx='809.228'
        cy='448.669'
        r='9'
        transform='rotate(45 809.228 448.669)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='844.787'
        cy='359.842'
        r='9'
        transform='rotate(45 844.787 359.842)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='749.104'
        cy='264.16'
        r='9'
        transform='rotate(45 749.104 264.16)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='661.278'
        cy='300.718'
        r='9'
        transform='rotate(45 661.278 300.718)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='825.08'
        cy='284.852'
        r='9'
        transform='rotate(45 825.08 284.852)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <g filter='url(#filter20_d_517_1164)'>
        <rect
          x='480.513'
          y='714.478'
          width='12.5551'
          height='50.2593'
          transform='rotate(-135 480.513 714.478)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter21_d_517_1164)'>
        <rect
          x='461.771'
          y='695.736'
          width='12.5551'
          height='50.2593'
          transform='rotate(-135 461.771 695.736)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter22_d_517_1164)'>
        <rect
          x='423.301'
          y='657.266'
          width='12.5551'
          height='50.2593'
          transform='rotate(-135 423.301 657.266)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M438.097 671.075L291.5 817.672'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M399.133 632.111L370.999 660.246L310.31 659.776'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M476.568 710.532L448.433 738.667L447.916 798.369'
        stroke='#0075FF'
        stroke-width='3'
      />
      <path
        d='M418.368 652.334L356.175 714.526L301.409 712.08L271.299 742.19'
        stroke='#0075FF'
        stroke-width='3'
      />
      <g filter='url(#filter23_d_517_1164)'>
        <rect
          x='442.042'
          y='676.008'
          width='12.5551'
          height='50.2593'
          transform='rotate(-135 442.042 676.008)'
          fill='#22DAF9'
        />
      </g>
      <g filter='url(#filter24_d_517_1164)'>
        <rect
          x='403.572'
          y='637.537'
          width='12.5551'
          height='50.2593'
          transform='rotate(-135 403.572 637.537)'
          fill='#22DAF9'
        />
      </g>
      <path
        d='M456.839 690.804L394.646 752.997L397.092 807.764L366.983 837.873'
        stroke='#0075FF'
        stroke-width='3'
      />
      <circle
        cx='299.942'
        cy='660.506'
        r='9'
        transform='rotate(-135 299.942 660.506)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='263.383'
        cy='749.333'
        r='9'
        transform='rotate(-135 263.383 749.333)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='360.066'
        cy='845.015'
        r='9'
        transform='rotate(-135 360.066 845.015)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='447.892'
        cy='808.456'
        r='9'
        transform='rotate(-135 447.892 808.456)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <circle
        cx='284.09'
        cy='824.322'
        r='9'
        transform='rotate(-135 284.09 824.322)'
        stroke='#0075FF'
        stroke-width='4'
      />
      <path
        d='M550.583 696.674L551.09 661.642L556.518 659.173L556.996 699.138L550.583 696.674Z'
        fill='#5BEDFC'
      />
      <path
        d='M562.437 662.131L556.518 659.172L556.996 699.138L562.424 696.669L562.437 662.131Z'
        fill='#29AFD9'
      />
      <path
        d='M665.603 549.115L700.634 549.595L703.099 555.022L663.133 555.531L665.603 549.115Z'
        fill='#5BEDFC'
      />
      <path
        d='M700.138 560.943L703.1 555.021L663.135 555.53L665.599 560.957L700.138 560.943Z'
        fill='#29AFD9'
      />
      <path
        d='M550.68 444.065L551.187 409.033L556.616 406.564L557.094 446.53L550.68 444.065Z'
        fill='#5BEDFC'
      />
      <path
        d='M562.535 409.522L556.616 406.564L557.094 446.53L562.522 444.06L562.535 409.522Z'
        fill='#29AFD9'
      />
      <path
        d='M413.968 548.226L448.999 548.706L451.464 554.133L411.498 554.642L413.968 548.226Z'
        fill='#5BEDFC'
      />
      <path
        d='M448.501 560.055L451.463 554.133L411.497 554.641L413.962 560.068L448.501 560.055Z'
        fill='#29AFD9'
      />
      <circle
        cx='461.497'
        cy='553.145'
        r='5'
        transform='rotate(-45 461.497 553.145)'
        fill='#22DAF9'
      />
      <circle
        cx='557.18'
        cy='648.827'
        r='5'
        transform='rotate(-45 557.18 648.827)'
        fill='#22DAF9'
      />
      <circle
        cx='555.279'
        cy='459.362'
        r='5'
        transform='rotate(-45 555.279 459.362)'
        fill='#22DAF9'
      />
      <circle
        cx='650.962'
        cy='555.045'
        r='5'
        transform='rotate(-45 650.962 555.045)'
        fill='#22DAF9'
      />
      <path
        d='M607.965 614.747L555.452 614.767C520.873 614.78 492.963 586.763 492.976 552.291C492.983 535.001 499.969 519.427 511.356 508.04C522.636 496.76 538.21 489.774 555.5 489.767C572.79 489.76 588.466 496.734 599.63 508.006C605.319 513.695 609.827 520.459 613.045 527.975C616.264 535.384 617.979 543.652 617.976 552.35C617.971 566.096 613.563 578.769 605.934 589.082C604.322 591.445 602.389 593.593 600.348 595.635L582.313 577.385C588.544 570.832 592.306 562.025 592.31 552.253C592.314 542.051 588.237 532.924 581.581 526.269C574.926 519.613 565.585 515.536 555.49 515.54C545.396 515.544 536.159 519.628 529.498 526.289C522.837 532.95 518.753 542.079 518.749 552.281C518.741 572.577 535.165 589.002 555.462 588.994L555.472 562.361L607.965 614.747Z'
        fill='url(#paint0_linear_517_1164)'
        className={isVisible ? styles.logo : null}
      />
      <mask
        id='mask0_517_1164'
        maskUnits='userSpaceOnUse'
        x='512'
        y='300'
        width='87'
        height='87'>
        <rect
          width='86'
          height='86'
          transform='matrix(1 -0.000385306 -0.000385306 1 513 300.791)'
          fill='url(#pattern0)'
        />
      </mask>
      <g mask='url(#mask0_517_1164)'>
        <rect
          width='86'
          height='86'
          transform='matrix(1 -0.000385306 -0.000385306 1 513 300.791)'
          fill='#0075FF'
        />
      </g>
      <mask
        id='mask1_517_1164'
        maskUnits='userSpaceOnUse'
        x='730'
        y='518'
        width='70'
        height='70'>
        <rect
          width='68.9474'
          height='68.9474'
          transform='matrix(1 -0.000385306 -0.000385306 1 730.456 518.538)'
          fill='url(#pattern1)'
        />
      </mask>
      <g mask='url(#mask1_517_1164)'>
        <rect
          width='68.9474'
          height='68.9474'
          transform='matrix(1 -0.000385306 -0.000385306 1 730.456 518.538)'
          fill='#0075FF'
        />
      </g>
      <mask
        id='mask2_517_1164'
        maskUnits='userSpaceOnUse'
        x='522'
        y='725'
        width='70'
        height='70'>
        <rect
          width='69'
          height='69'
          transform='matrix(1 -0.000385306 -0.000385306 1 523 725.791)'
          fill='url(#pattern2)'
        />
      </mask>
      <g mask='url(#mask2_517_1164)'>
        <rect
          width='69'
          height='69'
          transform='matrix(1 -0.000385306 -0.000385306 1 523 725.791)'
          fill='#0075FF'
        />
      </g>
      <mask
        id='mask3_517_1164'
        maskUnits='userSpaceOnUse'
        x='313'
        y='516'
        width='70'
        height='70'>
        <rect
          width='69'
          height='69'
          transform='matrix(1 -0.000385306 -0.000385306 1 314 516.791)'
          fill='url(#pattern3)'
        />
      </mask>
      <g mask='url(#mask3_517_1164)'>
        <rect
          width='69'
          height='69'
          transform='matrix(1 -0.000385306 -0.000385306 1 314 516.791)'
          fill='#0075FF'
        />
      </g>
      <image
        x='512'
        y='305'
        width='86px'
        height='86px'
        href={hands}
        xlinkHref={hands}></image>
      <image
        x='313'
        y='520'
        width='69px'
        height='69px'
        href={light}
        xlinkHref={light}></image>
      <image
        x='730'
        y='520'
        width='69px'
        height='69px'
        href={rocket}
        xlinkHref={rocket}></image>
      <image
        x='518'
        y='725'
        width='69px'
        height='69px'
        href={chart}
        xlinkHref={chart}></image>
      <defs>
        <filter
          id='filter0_f_517_1164'
          x='83.0541'
          y='97.8632'
          width='917.404'
          height='917.404'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feGaussianBlur
            stdDeviation='57'
            result='effect1_foregroundBlur_517_1164'
          />
        </filter>
        <filter
          id='filter1_d_517_1164'
          x='283.635'
          y='494.709'
          width='130.052'
          height='130.052'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='1' dy='8' />
          <feGaussianBlur stdDeviation='5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.52 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_d_517_1164'
          x='491.635'
          y='287.765'
          width='130.052'
          height='130.052'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='1' dy='8' />
          <feGaussianBlur stdDeviation='5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.52 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter3_d_517_1164'
          x='700.086'
          y='496.506'
          width='129.984'
          height='129.984'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='1' dy='8' />
          <feGaussianBlur stdDeviation='5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.52 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter4_d_517_1164'
          x='492.635'
          y='703.765'
          width='130.052'
          height='130.052'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='1' dy='8' />
          <feGaussianBlur stdDeviation='5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.52 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter5_d_517_1164'
          x='366.738'
          y='443.739'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter6_d_517_1164'
          x='386.481'
          y='423.996'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter7_d_517_1164'
          x='424.982'
          y='385.495'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter8_d_517_1164'
          x='406.225'
          y='404.251'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter9_d_517_1164'
          x='444.725'
          y='365.75'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter10_d_517_1164'
          x='642.998'
          y='562.049'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter11_d_517_1164'
          x='623.254'
          y='581.791'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter12_d_517_1164'
          x='584.754'
          y='620.292'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter13_d_517_1164'
          x='603.51'
          y='601.536'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter14_d_517_1164'
          x='565.01'
          y='640.037'
          width='102.396'
          height='102.396'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter15_d_517_1164'
          x='564.119'
          y='365.697'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter16_d_517_1164'
          x='582.861'
          y='384.439'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter17_d_517_1164'
          x='622.318'
          y='423.897'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter18_d_517_1164'
          x='602.59'
          y='404.168'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter19_d_517_1164'
          x='641.06'
          y='442.638'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter20_d_517_1164'
          x='442.635'
          y='641.062'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter21_d_517_1164'
          x='423.893'
          y='622.32'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter22_d_517_1164'
          x='385.423'
          y='583.849'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter23_d_517_1164'
          x='404.164'
          y='602.591'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <filter
          id='filter24_d_517_1164'
          x='365.694'
          y='564.121'
          width='102.417'
          height='102.417'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='14.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.133333 0 0 0 0 0.854902 0 0 0 0 0.976471 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_517_1164'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_517_1164'
            result='shape'
          />
        </filter>
        <pattern
          id='pattern0'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'>
          {/* <use xlink:href='#image0_517_1164' transform='scale(0.00195312)' /> */}
        </pattern>
        <pattern
          id='pattern1'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'>
          {/* <use xlink:href='#image1_517_1164' transform='scale(0.00195312)' /> */}
        </pattern>
        <pattern
          id='pattern2'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'>
          {/* <use xlink:href='#image2_517_1164' transform='scale(0.00195312)' /> */}
        </pattern>
        <pattern
          id='pattern3'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'>
          {/*  <use xlink:href='#image3_517_1164' transform='scale(0.00195312)' /> */}
        </pattern>
        <linearGradient
          id='paint0_linear_517_1164'
          x1='523.92'
          y1='615.848'
          x2='610.556'
          y2='480.431'
          gradientUnits='userSpaceOnUse'>
          <stop stop-color='#74EAE8' />
          <stop offset='1' stop-color='#0394E8' />
        </linearGradient>
        <image
          id='image0_517_1164'
          width='512'
          height='512'
          /* href={rasko}
          xlinkHref={rasko} */
        />

        <image id='image1_517_1164' width='512' height='512' />
        <image id='image2_517_1164' width='512' height='512' />
        <image id='image3_517_1164' width='512' height='512' />
      </defs>
    </svg>
  );
};
